import React, {
    useCallback,
    useState,
    useEffect,
    useRef,
  } from 'react';
  import {
    Routes,
    Route,
    Outlet,
    useNavigate,
    useLocation,
  } from 'react-router-dom';
  import { useTranslation } from 'react-i18next';
  import { useAppSelector, AppState, useAppDispatch } from './store';
  import { FlowStage } from './store/flow';
  import './App.css';
  import Thanks from './pages/Thanks';
  import UserInformation from './pages/UserInformation';
  import CompanyInformation from './pages/CompanyInformation';
  import MultiStepTrackerWrapper from './components/MultiStepTracker';
  import { ReactComponent as Logo } from './assets/svg/logo.svg';
  import CreatePassword from './pages/CreatePassword';
  import ErrorBoundary, { ErrorPage } from './pages/Error';
  const { CREATE_PASSWORD_URL, USER_INFORMATION_URL, COMPANY_INFORMATION_URL, THANK_YOU_URL, EMPTY_URL, ERROR_URL, FORGOT_PASSWORD_URL, LOGIN_URL, BASENAME, LOGOUT_API_URL, AOF_URL, TOKEN_NAME, FORGOT_EMAIL_SUCCESS, VERIFY_USER_URL,PCN_NO, NEW_USER_URL, SUCCESS_NEW_USER_URL, STATUS_URL, USER_DETAILS
  } = require('./helper/application-conf').default;
  
  import Login from './pages/Login';
  import useAxiosBuyer from './hooks/useAxiosBuyer';
  import useAxiosSecurity from './hooks/useAxiosSecurity';
  import { Person, User, userActions } from './store/user';
  import { Company, companyActions } from './store/company';
  import { createPayload } from './helper/payloadHelper';
  import { useAuth } from './hooks/useAuth';
  import { StorageService } from './helper/storage-service';
  import ForgotPassword from './pages/ForgotPassword';
  import ForgotEmailSuccess from './pages/ForgotEmailSuccess';
  import VerifyUser from './pages/VerifyUser';
  import { HeaderFooterService } from './service/axpHeaderFooterService';
  import BrandedNav from './components/BrandedNav';
  import NewUser from './pages/NewUser';
  import SuccessNewUser from './pages/SuccessNewUser';
  import { OneIdentityService } from './service/oneIdentityService';
  import axios from 'axios';
  import { Permissions, permissionsActions } from './store/permissions';
  import { axiosBuyerPassthrough, axiosOneId } from './hooks/axios';
import { mapApiDataToStores } from './helper/dataMapper';
import { authorizedOfficerActions } from './store/authorizedOfficer';
import useScript from './hooks/useScript';
  
  const {
    DefaultStyle, dlsBrightBlue, IconTelephone, DialogBox, DialogBoxBody, DialogBoxHeader, CopyLinkInput, ButtonPrimary, ButtonSecondaryDark, Button, IconClose, Alert, ButtonSecondary, ProgressCircle
  } = require('@americanexpress/dls-react');
  
  const Container = (props: { setAoEmailDuplicate: any, HeaderContainer: any, FooterContainer:any, page:any, oneIdentityEnabled:any, isLoading:any}) => {
    const { t } = useTranslation();
    const flowStage: FlowStage = useAppSelector((state: AppState) => state.flow.stage);
    const user: User = useAppSelector((state) => state.user);
    const authorizedOfficer: Person = useAppSelector((state) => state.authorizedOfficer);
    const company: Company = useAppSelector((state) => state.company);
    const axiosBuyer = useAxiosBuyer();
    const axiosSecurity = useAxiosSecurity();
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [urlModalOpen, setUrlModalOpen] = useState(false);
    const [dataUrl, setDataUrl] = useState('');
    const [copyLinkStatus, setCopyLinkStatus] = useState('default');
    const { setAoEmailDuplicate, HeaderContainer, FooterContainer, page, oneIdentityEnabled, isLoading} = props;
  
    const appState: AppState = useAppSelector((state) => state);
    const navigate = useNavigate();
  
    const SITE_NAME = window.location.pathname.split('/')[2];
    const { auth } = useAuth() as any;
    const location = useLocation().pathname;
    const storage = new StorageService();
    const oneIdentityService = new OneIdentityService();
    const axiosHandlerBuyer =  props.oneIdentityEnabled ? axiosBuyerPassthrough : axiosBuyer;
  
    useEffect(() => {
      if (!oneIdentityEnabled) {
        if (!storage.getSession(TOKEN_NAME) && (location === USER_INFORMATION_URL || location === COMPANY_INFORMATION_URL)) {
          navigate(LOGIN_URL);
          storage.removeSession(TOKEN_NAME);
        }
      }
    }, [auth, oneIdentityEnabled, isLoading]);

    const encodeAppState = useCallback(() => {
      if(oneIdentityEnabled) {
        setDataUrl(`${oneIdentityService.oneIdentityURL()}?DestPage=${window.location.origin}/buyer-onboarding/${SITE_NAME}/created-amexid`);
      }
      else {
        setDataUrl(`${window.location.origin}${BASENAME}/${SITE_NAME}${LOGIN_URL}`);
      }
    }, [appState, SITE_NAME]);
  
    const saveAppState = useCallback(() => {
      if (user.email === authorizedOfficer.email && !user.authorizedOfficer) {
        setAoEmailDuplicate(true);
        return;
      }
      encodeAppState();
      setConfirmationModalOpen(true);
    }, [encodeAppState]);
  
    const routeToLogin = useCallback(async (isConfirmDialog: boolean) => {
      if (isConfirmDialog) {
        setConfirmationModalOpen(false);
      } else {
        setCopyLinkStatus('default');
        setUrlModalOpen(false);
      }
      if (oneIdentityEnabled) {
        window.location.href = `${oneIdentityService.oneIdentityURL()}?DestPage=${window.location.origin}/buyer-onboarding/${SITE_NAME}/created-amexid`;
        storage.removeSession('role');
      } else {
        try {
          await axiosSecurity.post(
            LOGOUT_API_URL,
            null
          );
          navigate(LOGIN_URL);
        } catch {
          navigate(ERROR_URL);
        } finally {
          storage.removeSession(TOKEN_NAME);
        }
      }
    }, [navigate]);
  
    const saveUserCompanyInfo = async () => {
      try {
        const controller = new AbortController();
        await axiosHandlerBuyer.get(`${AOF_URL}${SITE_NAME}`, {
          signal: controller.signal,
        }).then(async (getResponse: any) => {
          if (getResponse.status !== 200 || getResponse === null) {
            navigate(ERROR_URL);
          }
          const store = [user, authorizedOfficer, company];
          const payload = createPayload(store, getResponse);
          await axiosHandlerBuyer.put(`${AOF_URL}${SITE_NAME}`, payload).then((putResponse: any) => {
            if (putResponse.status !== 200 || putResponse === null) {
              navigate(ERROR_URL);
            } else {
              setAoEmailDuplicate(false);
              setUrlModalOpen(true);
            }
          }, () => {
            navigate(ERROR_URL);
          });
        }, () => {
          navigate(ERROR_URL);
        });
      } catch (err) {
        navigate(ERROR_URL);
      }
    };
  
    return (
      <div>
        {(!oneIdentityEnabled) &&
          ( 
            <div>
            <BrandedNav>
              <Logo className="pad-l" title={t('logo_alt') || ''} />
              <div className="margin-r">
                <span className="displayHidden" >{t('need_help')}</span>
                <IconTelephone className="pad-1-lr displayHidden" />
                <span className="displayHidden" >{t('support_phone')}</span>
                {flowStage > FlowStage.CreatePassword && flowStage < FlowStage.ThankYou
                  && <ButtonSecondaryDark className="margin-1-l" size="sm" onClick={saveAppState}>Save &amp; Exit</ButtonSecondaryDark>}
              </div>
            </BrandedNav>
            <Outlet />
            </div>
          )
        }
  
        {(oneIdentityEnabled) &&
          (
            <div>
              <HeaderContainer />
              <div className="margin-4-r margin-t" style={{ float: 'right' }}>
                {flowStage > FlowStage.CreatePassword && flowStage < FlowStage.ThankYou
                  && <ButtonSecondary className="margin-1-l" size="sm" onClick={saveAppState}>Save &amp; Exit</ButtonSecondary>}
              </div>
               <Outlet />
            <div id='footer'>
              <FooterContainer />
            </div>
            </div>
          )}
  
        {confirmationModalOpen
          && (
            <DialogBox onClose={() => setConfirmationModalOpen(false)} id="confirmation-modal">
              <DialogBoxHeader id="confirmation-modal-header">
                <div className="flex flex-justify-between flex-align-items-center">
                  <h5 className="heading-5">{t('save_and_exit_modal.confirmation.header')}</h5>
                  <IconClose size="sm" role="button" theme={dlsBrightBlue} onClick={() => setConfirmationModalOpen(false)} />
                </div>
              </DialogBoxHeader>
              <DialogBoxBody id="confirmation-modal-body">
                <p className="body-1 pad-t">{t('save_and_exit_modal.confirmation.body')}</p>
                <hr className="margin-b margin-4-t" />
                <div className="flex flex-justify-end">
                  <Button size="md" styleType="tertiary" onClick={() => { routeToLogin(true); }}>{t('save_and_exit_modal.confirmation.negative')}</Button>
                  <ButtonPrimary
                    size="md"
                    className="margin-l"
                    onClick={() => {
                      saveUserCompanyInfo();
                      setConfirmationModalOpen(false);
                    }}
                  >{t('save_and_exit_modal.confirmation.positive')}
                  </ButtonPrimary>
                </div>
              </DialogBoxBody>
            </DialogBox>
          )}
        {urlModalOpen
          && (
            <DialogBox onClose={() => setUrlModalOpen(false)} id="copy-link-modal">
              <DialogBoxHeader id="copy-link-modal-header">
                <h3 className="heading-3">{t('save_and_exit_modal.saved.header')}</h3>
              </DialogBoxHeader>
              <DialogBoxBody className="save-modal" id="copy-link-modal-body">
                <p className="pad-4-b">{t('save_and_exit_modal.saved.body')}</p>
                <CopyLinkInput buttonText="Copy" status={copyLinkStatus} value={dataUrl} onSuccess={() => setCopyLinkStatus('success')} />
                <div className="text-align-left">
                  {copyLinkStatus === 'success'
                    && <Alert status={copyLinkStatus} showStateIcon={false}>{t('save_and_exit_modal.saved.success_message')}</Alert>}
                </div>
                <Button size="md" styleType="tertiary" onClick={() => { routeToLogin(false); }} id="close-button" className="margin-auto-lr margin-1-b margin-3-t">{t('save_and_exit_modal.saved.close')}</Button>
              </DialogBoxBody>
            </DialogBox>
          )}
      </div>
    );
  };
  
  const FormContainer: React.FC<any> = (props: { navigatedPage: any; oneIdentityEnabled: any}) => (
    <div>
      <div className="container">
        <div className={`row ${props.navigatedPage === "create-amexid" || props.navigatedPage === "created-amexid"? '' : 'pad-tb' }`}>
          <div className="col-md-offset-3 col-md-6">
            <MultiStepTrackerWrapper greyOut={false} oneIdentityEnabled={props.oneIdentityEnabled}/>
          </div>
        </div>
      </div>
      <Outlet />
    </div>
  );
  
  const App: React.FC = () => {  
    const SITENAME = window.location.pathname.split('/')[2];
    const PAGE = window.location.pathname.split('/')[3];
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const USER_ID = urlParams.get('userId') || '';
    const TOKEN = urlParams.get('token') || '';
    const ENROLLMENT = urlParams.get('enrollment') || '';
    const storage = new StorageService();
    const PCN = window.location.search.split('=').pop();
    const headerFooterService = new  HeaderFooterService();
    const [oneIdentityEnabled, setOneIdentityEnabled] = useState(false);
    const [isDAO, setisDAO] = useState(false);
    const appDispatch = useAppDispatch();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);

   
    if(PCN != ""){
      storage.setSession(PCN_NO, JSON.stringify(PCN));
    }
    const RSVP_CODE = urlParams.get('rsvpCode') || '';
    const [aoEmailDuplicate, setAoEmailDuplicate] = useState(false);
  
    const navigate = useNavigate();
  
    useEffect(() => {
      if(SITENAME === 'docupload'){
        setIsLoading(false);
        const pcn= storage.getSession(PCN_NO);
        const processControlNo = JSON.parse(pcn?pcn:'');
        const data = {status: 'docupload', pcn: processControlNo};
        navigate(LOGIN_URL, { state: {data} });
      }
      else {
        fetchConfig();
      }
    }, []);
  
    const fetchConfig = async () => {
      await axios.get(
        `/${SITENAME}${STATUS_URL}`
      ).then((response: any) => {
        setIsLoading(false)
        if (response && response.data && response.data?.isDAO === true) {
          setisDAO(true)
        }
        else {
          setisDAO(false)
        }
        if (response && response.data && response.data?.isOneIdentityEnabled === true) {
          setOneIdentityEnabled(true)
        }
        else {
          setOneIdentityEnabled(false);
        }
      });
    }
  
    const HeaderComponent = () => {
      return <div dangerouslySetInnerHTML={(
        headerFooterService.HTMLPartialsDecoder(headerFooterService.HeaderComponentURL()))
      } />
    }
  
    const FooterComponent = () => {
      return <div dangerouslySetInnerHTML={
        headerFooterService.HTMLPartialsDecoder(headerFooterService.FooterComponentURL())
      } />;
    }

    if (isLoading) {
      return <div className="row text-align-center pad-4-t flex flex-justify-center">
        <ProgressCircle size="lg" />
      </div>;
    }
  
    return (
      <ErrorBoundary>
        <div className={"App " + (PAGE === 'create-amexid' || PAGE === 'created-amexid'? 'dls-gray-01-bg': '')}>
          <DefaultStyle />
          <Routes>
            <Route element={<Container setAoEmailDuplicate={setAoEmailDuplicate} HeaderContainer={HeaderComponent} FooterContainer={FooterComponent} page={PAGE} oneIdentityEnabled={oneIdentityEnabled} isLoading={isLoading}/>}>
              <Route element={<FormContainer navigatedPage={PAGE} oneIdentityEnabled={oneIdentityEnabled}/>}>
                <Route index={true} path={LOGIN_URL} element={<Login siteName={SITENAME}/>} />
                <Route index={true} path={CREATE_PASSWORD_URL} element={<CreatePassword siteName={SITENAME} userID={USER_ID} token={TOKEN} enrollment={ENROLLMENT} />} />
                <Route path={USER_INFORMATION_URL} element={<UserInformation aoEmailDuplicate={aoEmailDuplicate} oneIdentityEnabled={oneIdentityEnabled}/>} />
                <Route path={COMPANY_INFORMATION_URL} element={<CompanyInformation oneIdentityEnabled={oneIdentityEnabled}/>} />
                <Route path={NEW_USER_URL} element={<NewUser/>} />
                <Route path={SUCCESS_NEW_USER_URL} element={<SuccessNewUser isDAO={isDAO}/>} />
              </Route>
              <Route path={VERIFY_USER_URL} element={<VerifyUser siteName={SITENAME} token={TOKEN} rsvpCode={RSVP_CODE} />} />
              <Route path={THANK_YOU_URL} element={<Thanks oneIdentityEnabled={oneIdentityEnabled}/>} />
              <Route path={ERROR_URL} element={<ErrorPage oneIdentityEnabled={oneIdentityEnabled}/>} />
              <Route path={FORGOT_EMAIL_SUCCESS} element={<ForgotEmailSuccess />} />
              <Route path={FORGOT_PASSWORD_URL} element={<ForgotPassword siteName={SITENAME}/>} />
            </Route>
            <Route path={EMPTY_URL} element={<ErrorPage />} />
          </Routes>
        </div>
      </ErrorBoundary>
    );
  };
  
  export default App;
  
